import { render } from "./ConfirmationDialogWithProps.vue?vue&type=template&id=77986a4c&scoped=true"
import script from "./ConfirmationDialogWithProps.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogWithProps.vue?vue&type=script&lang=js"

import "./ConfirmationDialogWithProps.vue?vue&type=style&index=0&id=77986a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77986a4c"]])

export default __exports__